import { Controller } from '@hotwired/stimulus';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';

export default class extends Controller {
  connect() {
    Highcharts.chart(this.element, JSON.parse(this.element.dataset.chartData));
  }
}
